import { render, staticRenderFns } from "./BenefitText.vue?vue&type=template&id=0af0281a&scoped=true"
import script from "./BenefitText.vue?vue&type=script&lang=js"
export * from "./BenefitText.vue?vue&type=script&lang=js"
import style0 from "./BenefitText.vue?vue&type=style&index=0&id=0af0281a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af0281a",
  null
  
)

export default component.exports